import { ScannedContainer, ScannedLocation } from 'client/scanner/scanner.types'

export function validateOrigin (origin: ScannedLocation | ScannedContainer) {

  if (origin.location && !['Storage','PreStorage'].includes(origin.location.type)) {
    throw Error('O-3: No se puede escanear una ubicación de Picking')
  }

  return origin
}
